import { Judge } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateAssignedJudge: (
  fetchContext: FetchContext,
  nominationId: number,
  userId: number,
  judge: Judge,
  countryId?: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, userId, judge, countryId, accessToken) => {
  const countryQuery = countryId === undefined ? '' : `?countryId=${countryId}`;

  return fetch(`${fetchContext.baseUrl}/api/staff/nominations/${nominationId}/judges/${userId}${countryQuery}`,
  {
    method: 'PUT',
    body: JSON.stringify(judge),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update assigned judge'));
};
